// Local translations
export const T = {
  en_GB: {
    description:
      "This component displays the profile image of the advisor who owns the client. The image is pulled from the advisor's profile settings.",
    width: "Width (%)",
    widthHelp: "Percentage of page width (10-100%)",
    alignment: "Alignment",
    left: "Left",
    center: "Center",
    right: "Right",
    shape: "Shape",
    circle: "Circle",
    square: "Square",
    shapeHelp: "Circle is typically used for profile photos",
  },
  nb_NO: {
    description:
      "Denne komponenten viser profilbildet til rådgiveren som eier kunden. Bildet hentes fra rådgiverens profilinnstillinger.",
    width: "Bredde (%)",
    widthHelp: "Prosent av sidebredde (10-100%)",
    alignment: "Justering",
    left: "Venstre",
    center: "Midtstilt",
    right: "Høyre",
    shape: "Form",
    circle: "Sirkel",
    square: "Kvadrat",
    shapeHelp: "Sirkel brukes vanligvis for profilbilder",
  },
} as const;
